<template>
  <!-- 患者対応 -->
  <div id="AppUrgentListResult">
    <div class="columns">
      <div class="column is-one-thirds" style="text-align: left">
        <b-button
          class="button is-primary has-text-centered"
          :disabled="!data.length"
          icon-left="printer"
          native-type="button"
          @click="printAll('all')"
          >報告書印刷（一括）</b-button
        >
        <b-button
          class="button is-primary has-text-centered"
          :disabled="!data.length"
          icon-left="printer"
          native-type="button"
          @click="showSupportReportable()"
          >報告書印刷（選択）</b-button
        >
      </div>
      <div class="column is-one-thirds">
        <b-field
          horizontal
          label="患者検索結果"
          style="float: right; white-space: nowrap"
        >
          <b-select position="is-right" v-model="perPage">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
          </b-select>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column if-full">
        <b-table
          :data="data"
          :paginated="isPaginated"
          :per-page="perPage"
          :current-page.sync="currentPage"
          :pagination-simple="isPaginationSimple"
          :pagination-position="paginationPosition"
          :pagination-size="paginationSize"
          :default-sort-direction="defaultSortDirection"
          detailed
          default-sort="patientCode"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <template slot-scope="props">
            <b-table-column centered>
              <b-radio
                v-model="selectedPatient"
                :native-value="props.row"
                @change.native="$emit('input', selectedPatient)"
              ></b-radio>
            </b-table-column>
            <b-table-column
              field="patientCode"
              label="患者コード"
              sortable
              centered
              >{{ props.row.patientCode }}</b-table-column
            >
            <b-table-column
              field="patientName"
              label="患者名"
              sortable
              centered
              >{{ props.row.patientName }}</b-table-column
            >
            <b-table-column
              field="patientNameKana"
              label="患者名（カナ）"
              sortable
              centered
              >{{ props.row.patientNameKana }}</b-table-column
            >
            <b-table-column
              :style="getGtActionStyle(props.row)"
              field="patientNameKana"
              label="患者管理チーム対応"
              sortable
              centered
              >{{ props.row.gtAction.name }}</b-table-column
            >
          </template>

          <template slot="detail" slot-scope="props">
            <div class="content">
              <table style="table-layout: fixed;">
                <template v-for="(prodItem, index) in props.row.productDetail">
                  <tr v-bind:key="prodItem.index">
                    <th style="width: 150px;" rowspan="4">機器情報 {{index + 1}}</th>
                    <th style="width: 150px;">機器名</th>
                    <td>{{ prodItem.productName }} ({{ prodItem.productCode }})</td>
                  </tr>
                  <tr v-bind:key="prodItem.index">
                    <th>シリアルNo.</th>
                    <td>{{ prodItem.serialNumber }}</td>
                  </tr>
                  <tr v-bind:key="prodItem.index">
                    <th>医療機関名</th>
                    <td>{{ prodItem.hospitalName }} ({{ prodItem.hospitalCode }})</td>
                  </tr>
                  <tr v-bind:key="prodItem.index">
                    <th> {{ $store.state.subSystem.staff.label }} </th>
                    <td> {{ prodItem.staffName }} </td>
                  </tr>
                </template>
                <tr></tr>
              </table>
            </div>
          </template>
        </b-table>
      </div>
    </div>

    <!-- 報告対象選択 -->
    <support-reportable-modal
      v-model="isShowSupportReportable"
      v-on:print="printAll('selected', $event)"
      :reportData="reportData"
    />
  </div>
</template>

<script>
import AppSupportReportable from "./AppSupportReportable.vue";
import * as patientUtils from "../utils/patient";

export default {
  name: "AppUrgentListResult",
  props: ["value"],

  methods: {
    search: async function (searchConditions) {
      this.searchConditions = searchConditions;
      // WebAPI Call
      await this.apiCall(
        this.getPatientSupportsPOST,
        this.getPatientSupportsPOSTSuccess,
        this.showErrorMessage,
        this.$store.state.subSystem
      );

      this.selectedPatient = null;
      this.$emit("input", this.selectedPatient);

      return;
    },

    // 患者対応一覧
    getPatientSupportsPOST: function (client) {
      const apiRes = client.apis.apiPatientSupport.getPatientSupportsPOST({
        body: {
          patientCode: this.searchConditions.patientCode,
          patientName: this.searchConditions.patientName,
          patientNameKana: this.searchConditions.patientNameKana,
          officeCode: this.searchConditions.officeCode,
          salseStaffCode: this.searchConditions.salesOfficerCode,
          salesStaffName: this.searchConditions.salesOfficerName,
          hospitalCode: this.searchConditions.hospitalCode,
          hospitalName: this.searchConditions.hospitalName,
          callDateStart: this.searchConditions.startDate,
          callDateEnd: this.searchConditions.endDate,
          gtActionGroup: this.searchConditions.gtActionGroup,
        },
      });
      return apiRes;
    },

    getPatientSupportsPOSTSuccess: function (result) {
      this.data = result.obj;
      return;
    },

    printAll: function (printType, hospitalList) {
      this.printType = printType;
      this.hospitalList = hospitalList;
      // 患者対応履歴: 報告書印刷
      this.downloadApiCall(
        this.getPatientSupportReportPOST,
        this.getPatientSupportReportPOSTError,
        this.$store.state.subSystem,
      );
    },

    getPatientSupportReportPOST: async function (client) {
      let patientList = [];
      if (this.printType == "all") {
        for (const row of this.data) {
          patientList.push({
            patientCode: row.patientCode,
          });
        }
      }

      const apiRes = await client.apis.apiPatientSupport.getPatientSupportReportPOST({
        body: {
          responseMode: this.responseMode,
          printType: this.printType,
          callDateStart: this.searchConditions.startDate,
          callDateEnd: this.searchConditions.endDate,
          hospitalCode: this.searchConditions.hospitalCode,
          hospitalName: this.searchConditions.hospitalName,
          salesOfficerName: this.searchConditions.salesOfficerName,
          patientList: patientList,
          hospitalList: this.hospitalList ? this.hospitalList : [],
        },
      });

      this.hospitalList = null;

      return apiRes;
    },

    getPatientSupportReportPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },

    showSupportReportable: async function () {
      this.printType = "all";
      this.responseMode = "data";
      await this.apiCall(
        this.getPatientSupportReportPOST,
        this.getPatientSupportReportDataSuccess,
        this.showErrorMessage,
        this.$store.state.subSystem
      );
      this.printType = null;
      this.responseMode = null;
      this.isShowSupportReportable = true;
      return;
    },

    getPatientSupportReportDataSuccess: function (result) {
      this.reportData = result.obj;
      return;
    },

    getGtActionStyle: function (row) {
      const gtActionStyle = row.gtAction.code == patientUtils.GT_ACTION_MAP.actionRequired.code ? "color:red" : "";
      return gtActionStyle;
    }
  },

  data() {
    return {
      data: [],
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 10,
      selectedPatient: null,
      isShowSupportReportable: false,
      printType: null,
      searchConditions: null,
      responseMode: null,
      reportData: null,
    };
  },
  filters: {},
  components: {
    "support-reportable-modal": AppSupportReportable,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AppUrgentListResult.vue